import servicesLayout from "@/views/Services/Layout/index.vue";

export default [
  {
    path: "",
    redirect: "notices",
    component: servicesLayout,
    children: [
      {
        path: "notices",
        component: () => import("@/views/Services/Notices/index.vue"),
      },
      {
        path: "faq",
        component: () => import("@/views/Services/Faq/index.vue"),
      },
      {
        path: "tos",
        component: () => import("@/views/Services/Tos/index.vue"),
      },
    ],
  },
];
